import { Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import DrawerPageLayout from '../components/drawerWrapper';
import { AssessmentGradingScreen, AssessmentListScreen, AssessmentViewScreen, CreateAssessmentScreen } from '../pages/assessment';
import { StudentListScreen, UploadAnswerScreen } from '../pages/student';
import StudentOnboardingScreen from '../pages/student/onboarding';
import { useIsLoggedIn, useUser } from '../redux/useStore';
import { ReactNode, useEffect } from 'react';
import { trackUtmParameters } from '../utils/analytics/analytics';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { googleClientId } from '../config/envConfig';
import { ToastContainer } from 'react-toastify';
import { Login, ForgotPassword, Signup, Profile } from '../pages/user';
import { SubjectListScreen, SubjectViewScreen, ChapterListView } from '../pages/subject';
import { TestViewScreen, InstructionsListScreen, TestGradingScreen, EndTestScreen, TestAnalysisScreen } from '../pages/test';
import Renderer from '../pages/admin/renderer';
import StudentOverview from '../pages/student/overview';


const drawerWrapped = (component: ReactNode) => {
  return (
    <DrawerPageLayout>
      {component}
    </DrawerPageLayout>
  )
}




const AppRoutes = () => {
  const isLoggedIn = useIsLoggedIn()
  const user = useUser();
  const navigate = useNavigate();
  const location = useLocation();



  useEffect(() => {
    if (user?.role === 'student') {
      if (!user?.educationalInfo) {
        navigate('/assessments/student/onboarding');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  useEffect(() => {
    // tracking UTM parameters whenever location changes
    trackUtmParameters();
  }, [location]);

  // Protected Routes
  if (!isLoggedIn) {

    return (
      <GoogleOAuthProvider clientId={googleClientId}>
        <ToastContainer position="top-right" autoClose={3000} />
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </GoogleOAuthProvider>
    )
  }

  // Redirect students to onboarding screen after login
  if (user?.role === 'student') {
    return (
      <Routes>
        <Route path="/assessments/student/onboarding" element={<StudentOnboardingScreen />} />
        <Route path="/" element={drawerWrapped(<SubjectListScreen />)} />


        <Route path='/assessments'>
          <Route index path='' element={drawerWrapped(<AssessmentListScreen />)} />
          <Route path='view' element={drawerWrapped(<AssessmentViewScreen />)} />
        </Route>

        <Route path='/subject'>
          <Route index path='' element={drawerWrapped(<SubjectListScreen />)} />
          <Route path='view' element={drawerWrapped(<SubjectViewScreen />)} />
          <Route path='chapters' element={drawerWrapped(<ChapterListView />)} />
        </Route>

        <Route path='/test' >
          <Route index path='' element={drawerWrapped(<TestViewScreen />)} />
          <Route path='instructions' element={drawerWrapped(<InstructionsListScreen />)} />
          <Route path='view' element={drawerWrapped(<TestViewScreen />)} />
          <Route path='grading' element={drawerWrapped(<TestGradingScreen />)} />
          <Route path='end' element={drawerWrapped(<EndTestScreen />)} />
          <Route path='analysis' element={drawerWrapped(<TestAnalysisScreen />)} />
        </Route>

        <Route path='/settings' element={drawerWrapped(<Profile />)} />
        {/* <Route path='/renderer' element={drawerWrapped(<Renderer />)} /> */}
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/" element={drawerWrapped(<SubjectListScreen />)} />

      <Route path='/assessments'>
        <Route index path='' element={drawerWrapped(<AssessmentListScreen />)} />
        <Route path='view' element={drawerWrapped(<AssessmentViewScreen />)} />
        <Route path='create' element={drawerWrapped(<CreateAssessmentScreen />)} />
        <Route path="students" element={drawerWrapped(<StudentListScreen />)} />
        <Route path="grading" element={drawerWrapped(<AssessmentGradingScreen />)} />
        <Route path="submission" element={drawerWrapped(<UploadAnswerScreen />)} />
        <Route path="analysis" element={drawerWrapped(<StudentOverview />)} />
      </Route>



      <Route path='/subject'>
          <Route index path='' element={drawerWrapped(<SubjectListScreen />)} />
          <Route path='view' element={drawerWrapped(<SubjectViewScreen />)} />
          <Route path='chapters' element={drawerWrapped(<ChapterListView />)} />
        </Route>

        <Route path='/test' >
          <Route index path='' element={drawerWrapped(<TestViewScreen />)} />
          <Route path='instructions' element={drawerWrapped(<InstructionsListScreen />)} />
          <Route path='view' element={drawerWrapped(<TestViewScreen />)} />
          <Route path='grading' element={drawerWrapped(<TestGradingScreen />)} />
          <Route path='end' element={drawerWrapped(<EndTestScreen />)} />
          <Route path='analysis' element={drawerWrapped(<TestAnalysisScreen />)} />
        </Route>
        



      <Route path='/settings' element={drawerWrapped(<Profile />)} />
      <Route path='/renderer' element={drawerWrapped(<Renderer />)} />
   
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AppRoutes;